import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('zoomMeetingsV2');

export default resourceActions;
